export default __webpack_public_path__ + "static/media/maybach.705cacf8.svg";